import React from 'react';
import connectField    from 'uniforms/connectField';
import {createElement} from 'react';

const ReadOnlyTextMiddle = (props) => {
    return(
        <div className={'form-bg-light-grey-nr'} style={{paddingBottom: 0, paddingTop: 0}}>
            <div className={'form-bg-dark-grey'} style={{borderRadius: 0, marginBottom: 0, marginTop: 0, paddingBottom: 3, paddingTop: 3}}>
                {createElement(props.tag, {dangerouslySetInnerHTML: {__html: props.html ? props.html : props.label}})}
            </div>
        </div>
    );
}

ReadOnlyTextMiddle.defaultProps = {
    tag: 'div'
};

export default connectField(ReadOnlyTextMiddle);
